<div class="download__apps flex flex-col gap-8 my-14">
  <h2 class="text-white" translate="Get Our App for Seamless Access"></h2>

  <p translate>
    Experience the full power of our tools on the go. Download our app for
    instant access anytime, anywhere
  </p>

  <div
    class="flex justify-center items-center gap-4 download__methods"
    (click)="
      alertService.error_toastr('Mobile apps under development are coming soon')
    "
  >
    <a
      href="javascript:void"
      [attr.aria-label]="'Download iOS App' | translate | async"
    >
      <div inlineSVG="footer/appstore.svg"></div>
    </a>
    <a
      href="javascript:void"
      [attr.aria-label]="'Download Android App' | translate | async"
    >
      <div inlineSVG="footer/googleplay.svg"></div>
    </a>
  </div>
</div>
